module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-leadership-bg-2-902a032ffe3e9d7b9d38d14b7f908e5c.png";